import { Navigate, NavLink, Outlet } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import {
  canAccessDepartments,
  canAccessPlatformConfig,
  canViewSla,
  getDefaultPlatformConfigPath,
} from '../../utils/permissions';
import { PLATFORM_CONFIG } from './paths';

type TabDef = {
  to: string;
  label: string;
  visible: boolean;
};

export default function PlatformConfigLayout() {
  const { user } = useAuth();

  const tabs: TabDef[] = user
    ? [
        {
          to: PLATFORM_CONFIG.channelTypes,
          label: 'Channel Types',
          visible: canAccessPlatformConfig(user),
        },
        {
          to: PLATFORM_CONFIG.labels,
          label: 'Labels',
          visible: canAccessPlatformConfig(user),
        },
        {
          to: PLATFORM_CONFIG.categories,
          label: 'Categories',
          visible: canAccessPlatformConfig(user),
        },
        {
          to: PLATFORM_CONFIG.statuses,
          label: 'Statuses',
          visible: canAccessPlatformConfig(user),
        },
        {
          to: PLATFORM_CONFIG.channels,
          label: 'Channels',
          visible: canAccessPlatformConfig(user),
        },
        {
          to: PLATFORM_CONFIG.sources,
          label: 'Sources',
          visible: canAccessPlatformConfig(user),
        },
        {
          to: PLATFORM_CONFIG.routing,
          label: 'Routing',
          visible: canAccessPlatformConfig(user),
        },
        {
          to: PLATFORM_CONFIG.departments,
          label: 'Departments',
          visible: canAccessDepartments(user),
        },
        {
          to: PLATFORM_CONFIG.sla,
          label: 'SLA Rules',
          visible: canViewSla(user),
        },
      ].filter((tab) => tab.visible)
    : [];

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Platform Config</h1>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--text-muted)', fontSize: '0.9rem' }}>
            Master data — channel types, labels, categories, statuses, channels, sources, routing, departments, and SLA rules.
          </p>
        </div>
      </div>

      {tabs.length > 0 && (
        <nav className="tabs" aria-label="Platform config sections">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) => (isActive ? 'tab active' : 'tab')}
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      )}

      <Outlet />
    </>
  );
}

export function PlatformConfigHomeRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={getDefaultPlatformConfigPath(user)} replace />;
}
